'use strict'

/**
 * Module de gestion des modales
 */

function creer(
    id,
    classCss,
    url,
    callback,
    type,
    data,
    contentType,
    forcereload = false
) {
    if (forcereload) {
        $('#' + id).html('')
    } else {
        if ($('#' + id).length > 0) {
            $('#' + id).modal('show')

            return
        }
    }
    // si la modal existe déjà on l'ouvre

    // sinon on crée la modal
    $('body').append(
        '<div id="' +
            id +
            '" class="modal ' +
            classCss +
            '" tabindex="-1" role="dialog"></div>'
    )
    $('#' + id).append('<div class="modal-dialog"></div>')
    $('#' + id + '> .modal-dialog').append('<div class="modal-content"></div>')

    // on l'ouvre
    $('#' + id).modal()

    // on met à jour son contenu par ajax

    $.ajax({
        type: type == undefined ? 'GET' : type,
        url: url,
        data: data,
        contentType: contentType,
        success: function (reponse) {
            $('#' + id + '> .modal-dialog > .modal-content').html(reponse)

            // on appelle le callback
            if (callback !== undefined) {
                callback()
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            $('#' + id).modal('hide')
            $('#' + id).remove()
        }
    })
}

function miseAjourParClassCss(cssClassSelector, url, callback) {
    let classname = cssClassSelector

    if (!classname.startsWith('.')) {
        classname = '.' + classname
    }

    if ($(classname).length == 0) {
        return
    }

    if ($(classname).hasClass('loaded')) {
        return
    }

    $(classname).addClass('loaded')

    // on met à jour son contenu par ajax

    $.ajax({
        type: 'GET',
        url: url,
        success: function (reponse) {
            $(classname).html(reponse)

            // on appelle le callback
            if (callback !== undefined) {
                callback()
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            $(classname).modal('hide')
        }
    })
}

function supprimer(id) {
    $('#' + id).remove()
}

export default {
    creer: creer,
    supprimer: supprimer,
    miseAjourParClassCss: miseAjourParClassCss
}
